module.exports = __webpack_public_path__ + "static/media/photo-2019-09-11-13-26-12_1x.46bf5e37.jpg";